
import { pick } from '@shared/lib/collections'
import { getFirstQueryValue } from '@shared/lib/routes'

import { useDemoShiftControlStore } from './store'

interface ButtonFiltersSubmitReturn {
  name: string
  text: string
  disabled: ComputedRef<boolean>
  setSubmit: () => Promise<void>
}

export const useButtonFiltersSubmit = (): ButtonFiltersSubmitReturn => {
  const name = 'button_slots_tracker_filters_submit'
  const text = 'Search'

  const route = useRoute()
  const router = useRouter()
  const demoShiftControlStore = useDemoShiftControlStore()

  const isFiltersMatchQuery = computed<boolean>(() => {
    const queryFrom = getFirstQueryValue(route.query?.from)
    const queryTo = getFirstQueryValue(route.query?.to)
    const queryReservationType = getFirstQueryValue(route.query?.reservation_types)
    const queryStatus = getFirstQueryValue(route.query?.statuses)
    const querySortBy = getFirstQueryValue(route.query?.sort_by)

    return (
      queryFrom === (demoShiftControlStore.getFilterFrom || null)
      && queryTo === (demoShiftControlStore.getFilterTo || null)
      && queryReservationType === (demoShiftControlStore.getFilterReservationType || null)
      && queryStatus === (demoShiftControlStore.getFilterSlotStatus || null)
      && querySortBy === (demoShiftControlStore.getFilterSortBy || null)
    )
  })

  const disabled = computed(() => demoShiftControlStore.isShiftControlBusy || isFiltersMatchQuery.value)

  const setSubmit = async (): Promise<void> => {
    const query = pick({
      ...demoShiftControlStore.getFilterParams,
      current_page: String(demoShiftControlStore.getCurrentPage),
      per_page: String(demoShiftControlStore.getPerPage),
    })

    await router.push({ query })
  }

  return {
    name,
    text,
    disabled,
    setSubmit,
  }
}
